"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gridConfig = require("../../fuse-responsive-grid/src/grid-config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledButtonGroup = (0, _styledComponents["default"])(_fuseUtils.ResizeStackedCTA).attrs({
  className: 'fuse-button-group'
}).withConfig({
  displayName: "styled-button-group__StyledButtonGroup",
  componentId: "sc-hgj06p-0"
})(["width:100%;@media screen and (min-width:", "){width:unset;}"], _gridConfig.gridConfig.m.minWidth);
var _default = exports["default"] = StyledButtonGroup;